/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { ContractDocumentsControllerRemoveMutationResponse, ContractDocumentsControllerRemovePathParams, ContractDocumentsControllerRemove401, ContractDocumentsControllerRemove403, ContractDocumentsControllerRemove404 } from "../../models/contractDocumentsController/ContractDocumentsControllerRemove";

function getContractDocumentsControllerRemoveUrl(id: ContractDocumentsControllerRemovePathParams["id"]) {
  const res = { method: 'DELETE', url: `/api/v1/contract-documents/${id}` as const }  
  return res
}

/**
 * @summary Remove the contract document association (the file stays in the project)
 * {@link /api/v1/contract-documents/:id}
 */
export async function contractDocumentsControllerRemove(id: ContractDocumentsControllerRemovePathParams["id"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<ContractDocumentsControllerRemoveMutationResponse, ResponseErrorConfig<ContractDocumentsControllerRemove401 | ContractDocumentsControllerRemove403 | ContractDocumentsControllerRemove404>, unknown>({ method : "DELETE", url : getContractDocumentsControllerRemoveUrl(id).url.toString(), ... requestConfig })  
  return res.data
}